import React, { useEffect } from 'react';
import { UrgencyBar } from './components/UrgencyBar';
import { Hero } from './components/Hero';
import { ForYou } from './components/ForYou';
import { Transition } from './components/Transition';
import { SavingsCalculator } from './components/SavingsCalculator';
import { Features } from './components/Features';
import { Price } from './components/Price';
import { Bonuses } from './components/Bonuses';
import { SocialProof } from './components/SocialProof';
import { LogicStack } from './components/LogicStack';
import { Guarantee } from './components/Guarantee';
import { FooterCTA } from './components/FooterCTA';
import { RecentPurchaseToast } from './components/RecentPurchaseToast';
import { initMetaPixel, trackPageView, trackViewContent } from './utils/metaPixel';
export function App() {
  useEffect(() => {
    // Initialize Meta Pixel and fire PageView
    initMetaPixel();
    trackPageView();
    // Fire ViewContent when user scrolls to #comprar section
    const priceSection = document.getElementById('comprar');
    if (!priceSection) return;
    let hasFiredViewContent = false;
    const observer = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (entry.isIntersecting && !hasFiredViewContent) {
          hasFiredViewContent = true;
          trackViewContent({
            content_name: 'El Método Barrita Pro',
            content_type: 'product',
            value: 16990,
            currency: 'ARS'
          });
        }
      });
    }, {
      threshold: 0.3
    });
    observer.observe(priceSection);
    return () => observer.disconnect();
  }, []);
  return <div className="w-full min-h-screen bg-[#F8FAFC]" data-id="element-0">
      <UrgencyBar data-id="element-1" />
      <Hero data-id="element-2" />
      <hr className="border-none h-px bg-[#E2E8F0] m-0" data-id="element-3" />
      <ForYou data-id="element-4" />
      <Transition data-id="element-5" />
      <SavingsCalculator data-id="element-6" />
      <Features data-id="element-7" />
      <Price data-id="element-8" />
      <Bonuses data-id="element-9" />
      <SocialProof data-id="element-10" />
      <LogicStack data-id="element-11" />
      <Guarantee data-id="element-12" />
      <FooterCTA data-id="element-13" />
      <RecentPurchaseToast data-id="element-14" />
    </div>;
}